import { useMutation } from '@tanstack/react-query';
import { confirmConsent } from '../api/invitationApi';

/**
 * Mutation hook for confirming data sharing consent.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useConfirmConsent() {
  return useMutation({
    mutationFn: ({ invitationId }: { invitationId: string }) =>
      confirmConsent(invitationId, { consent: true }),
  });
}
